export const BLOCK_DEFINITIONS = [
  // ── Existing ──────────────────────────────────────────────────────
  { type: 'hero', label: 'Hero Section', icon: 'bi bi-image' },
  { type: 'text', label: 'Text Section', icon: 'bi bi-text-paragraph' },
  { type: 'image', label: 'Image', icon: 'bi bi-card-image' },
  { type: 'divider', label: 'Divider', icon: 'bi bi-dash-lg' },
  { type: 'agendaSnippet', label: 'Agenda Snippet', icon: 'bi bi-list-check' },
  { type: 'carousel', label: 'Carousel', icon: 'bi bi-images' },
  { type: 'collage', label: 'Collage', icon: 'bi bi-grid-3x3' },
  { type: 'video', label: 'Video Embed', icon: 'bi bi-play-circle-fill' },
  // ── Typography ─────────────────────────────────────────────────────
  { type: 'heading', label: 'Heading', icon: 'bi bi-type-h1' },
  { type: 'paragraph', label: 'Paragraph', icon: 'bi bi-paragraph' },
  { type: 'html', label: 'HTML', icon: 'bi bi-code-slash' },
  { type: 'quote', label: 'Quote', icon: 'bi bi-chat-quote-fill' },
  { type: 'callout', label: 'Callout Box', icon: 'bi bi-chat-left-dots-fill' },
  { type: 'badge', label: 'Badge / Label', icon: 'bi bi-tag-fill' },
  // ── Lists & Accordions ─────────────────────────────────────────────
  { type: 'bulletList', label: 'List', icon: 'bi bi-list-ul' },
  { type: 'faq', label: 'FAQ', icon: 'bi bi-question-circle-fill' },
  { type: 'accordion', label: 'Accordion', icon: 'bi bi-chevron-bar-down' },
  { type: 'toggleBlock', label: 'Toggle Block', icon: 'bi bi-toggle-off' },
  // ── Layout ─────────────────────────────────────────────────────────
  { type: 'dataCard', label: 'Card', icon: 'bi bi-card-text' },
  { type: 'columns', label: 'Columns', icon: 'bi bi-layout-three-columns' },
  { type: 'cardGrid', label: 'Card Grid', icon: 'bi bi-grid-fill' },
  // ── Media ──────────────────────────────────────────────────────────
  { type: 'audio', label: 'Audio Embed', icon: 'bi bi-music-note-beamed' },
  { type: 'pdf', label: 'PDF Viewer', icon: 'bi bi-file-pdf-fill' },
  // ── Navigation ─────────────────────────────────────────────────────
  { type: 'breadcrumbs', label: 'Breadcrumbs', icon: 'bi bi-signpost-2-fill' },
  { type: 'button', label: 'Button', icon: 'bi bi-ui-checks-grid' },
  // ── Interactive ────────────────────────────────────────────────────
  { type: 'countdown', label: 'Countdown Timer', icon: 'bi bi-alarm-fill' },
  { type: 'poll', label: 'Poll / Vote', icon: 'bi bi-bar-chart-line-fill' },
  { type: 'announcement', label: 'Announcement', icon: 'bi bi-megaphone-fill' },
];

export const defaultContent = (type) => {
  switch (type) {
    case 'hero': return {
      title: '',
      subtitle: '',
      backgroundUrl: '',
      titleColor: '',
      subtitleColor: '',
      heroBackgroundColor: '#001b34',
      heroLayers: [],
    };
    case 'text': return { body: '' };
    case 'image': return {
      url: '',
      originalSourceUrl: '',
      caption: '',
      alt: '',
      resizeUnit: 'px',
      resizeWidth: 1024,
      resizeHeight: 1024,
      resizedWidthPx: 1024,
      resizedHeightPx: 1024,
      resizeBaseWidth: 1024,
      resizeBaseHeight: 1024,
      resizeQuality: 92,
      fileType: 'jpg',
      resizedBytes: 0,
      resizedMimeType: 'image/jpeg',
      lockAspectRatio: true,
      aspectRatio: 1,
      intrinsicAspectRatio: 1,
      displayHeight: 320,
      widthPercent: 100,
      borderRadius: 10,
      linkType: 'none',
      pageId: '',
      appPath: '',
      externalUrl: '',
      openExternalInNewTab: true,
    };
    case 'divider': return {};
    case 'agendaSnippet': return { meetingId: '', label: '' };
    case 'carousel': return {
      title: '',
      subtitle: '',
      slides: [{ id: makeSubItemId('slide'), imageUrl: '', caption: '' }],
      autoPlay: true,
      intervalMs: 3500,
      transition: 'slide',
      showArrows: true,
      showIndicators: true,
      pauseOnHover: true,
      loop: true,
    };
    case 'collage': return { images: [{ id: makeSubItemId('img'), url: '', alt: '' }] };
    case 'video': return { embedUrl: '', title: '', caption: '' };
    // Typography
    case 'heading': return { level: 'h2', text: '', icon: '' };
    case 'paragraph': return { text: '' };
    case 'html': return { html: '' };
    case 'quote': return { text: '', author: '', icon: '' };
    case 'callout': return { text: '', variant: 'info', icon: '' };
    case 'badge': return { items: [{ id: makeSubItemId('badge'), text: '', variant: 'primary', icon: '' }] };
    // Lists & Accordions
    case 'bulletList': return { style: 'bullet', items: [{ id: makeSubItemId('li'), text: '' }] };
    case 'faq': return { items: [{ id: makeSubItemId('faq'), question: '', answer: '', icon: '' }] };
    case 'accordion': return { items: [{ id: makeSubItemId('acc'), title: '', blocks: [] }] };
    case 'toggleBlock': return { label: '', content: '' };
    // Layout
    case 'dataCard': return {
      icon: '',
      title: '',
      titleLevel: 'h3',
      subtitle: '',
      blocks: [],
    };
    case 'columns': return { count: 2, cols: [{ id: makeSubItemId('col'), title: '', content: '' }, { id: makeSubItemId('col'), title: '', content: '' }] };
    case 'cardGrid': return { columns: 3, cards: [{ id: makeSubItemId('card'), title: '', titleLevel: 'h5', body: '', imageUrl: '', buttonLabel: '', buttonUrl: '', buttonVariant: 'primary', icon: '' }] };
    // Media
    case 'audio': return { url: '', title: '', caption: '' };
    case 'pdf': return { url: '', title: '', height: 480 };
    // Navigation
    case 'breadcrumbs': return { items: [{ id: makeSubItemId('bc'), label: 'Home', url: '/', icon: '' }, { id: makeSubItemId('bc'), label: 'Current Page', url: '', icon: '' }] };
    case 'button': return { label: 'Click here', url: '', variant: 'primary', size: 'md', align: 'left', openNewTab: false, icon: '' };
    // Interactive
    case 'countdown': return { targetDate: '', title: '', completedMessage: 'Time is up!', icon: '' };
    case 'poll': return { question: '', options: [{ id: makeSubItemId('opt'), text: '' }, { id: makeSubItemId('opt'), text: '' }], allowMultiple: false };
    case 'announcement': return { text: '', variant: 'info', dismissible: true, icon: '' };
    default: return {};
  }
};

export const makeBlockId = () =>
  `block-${Date.now()}-${Math.floor(Math.random() * 10000)}`;

export const makePageId = () =>
  `page-${Date.now()}-${Math.floor(Math.random() * 10000)}`;

export const makeSubItemId = (prefix) =>
  `${prefix}-${Date.now()}-${Math.floor(Math.random() * 10000)}`;
